import React from 'react';
import { ChatMessageWidget } from '@wix/chat-widget-common-widgets';
import { WidgetCommonContext } from '../types';
import { CONNECT_CALENDAR_WIDGET, ConnectCalendarWidget } from './ConnectCalendarWidget';
import { DOWNLOAD_APP_WIDGET, DownloadAppWidget } from './DownloadApp';
import { NOWNIA_FALLBACK_WIDGET, NowniaFallbackWidget } from './NowniaFallbackWidget';

export const getSchedulingChatWidgets = (context: WidgetCommonContext): ChatMessageWidget[] => {
  return [
    {
      widgetName: DOWNLOAD_APP_WIDGET,
      component: (data: any) => <DownloadAppWidget data={data} context={context} />,
    },
    {
      widgetName: CONNECT_CALENDAR_WIDGET,
      component: (data: any) => <ConnectCalendarWidget data={data} context={context} />,
    },
    {
      widgetName: NOWNIA_FALLBACK_WIDGET,
      component: (data: any) => <NowniaFallbackWidget data={data} context={context} />,
    },
  ];
};
